import { render, staticRenderFns } from "./CoContentSection.vue?vue&type=template&id=2e4c12fa&scoped=true&"
import script from "./CoContentSection.vue?vue&type=script&lang=ts&"
export * from "./CoContentSection.vue?vue&type=script&lang=ts&"
import style0 from "./CoContentSection.vue?vue&type=style&index=0&id=2e4c12fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c12fa",
  null
  
)

export default component.exports